module.exports = __webpack_public_path__ + "static/media/stop_screen_share.7ae989da.svg";